<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "Paythings",
      // all titles will be injected into this template
      titleTemplate: "Paythings",
    };
  },
  mounted(){

}
};
</script>
